import script from "./MDChangeView.vue?vue&type=script&setup=true&lang=js"
export * from "./MDChangeView.vue?vue&type=script&setup=true&lang=js"

import "./MDChangeView.vue?vue&type=style&index=0&id=38d1796f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d1796f"]])

export default __exports__